import { render } from "./UpcomingJobs.vue?vue&type=template&id=60d2c6b8"
import script from "./UpcomingJobs.vue?vue&type=script&lang=js"
export * from "./UpcomingJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__